import { combineReducers } from 'redux';
import projects from './loading/projects.reducer';
import project from './loading/project.reducer';

const loadingReducer = combineReducers({ projects, project });

export default loadingReducer;

export type LoadingState = ReturnType<typeof loadingReducer>;
